module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.7490/img/video-thumb-overlay.png"